import { iframeDataBridge } from '@/iframe/iframeDataBridge';
import { authenticatedFetch, getApiUrl } from '@/utils/auth/authService';
import { log } from '@/utils/core/vueLogger.js';
import { CacheManager } from '@/utils/core/cacheManager.js';

const clusteringCache = new CacheManager('VueCache', 'cache', {
	maxAge: 24 * 60 * 60 * 1000,
	memoryCacheTTL: 30 * 60 * 1000,
	logCategory: 'Clustering',
	keyPrefix: () => `${iframeDataBridge.getCustomer() ?? 'unknown'}.${iframeDataBridge.getCurrentUser()?.id ?? 'unknown'}.clusterings.`,
});

export async function getClusterings(forceRefresh = false) {
	if (!forceRefresh && !clusteringCache.getFromMemory('all')) {
		try {
			const legacyData = await iframeDataBridge.getStorageAsync('CLUSTERINGS');
			if (legacyData) {
				log('info', 'Clustering', '📦 Seeding Vue cache from legacy storage (CLUSTERINGS)');
				await clusteringCache.put('all', legacyData);
				clusteringCache.setInMemory('all', legacyData);
				return legacyData;
			}
		} catch (legacyError) {
			log('warn', 'Clustering', `⚠️ Legacy storage check failed: ${legacyError.message}`);
		}
	}

	return clusteringCache.fetchOrCache('all', fetchClusteringsFromAPI, { forceRefresh, fallback: [], backgroundRefresh: true });
}

async function fetchClusteringsFromAPI() {
	const response = await authenticatedFetch(getApiUrl('Sales/Clusterings'), { method: 'GET' }, 'tokenSales');
	if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

	const clusterings = await response.json();
	log('success', 'Clustering', `✅ Fetched ${clusterings.length} clusterings`);
	return clusterings;
}

export async function refreshClusterings() {
	clusteringCache.clearMemory();
	await clusteringCache.clear();
}
